import { getPresetValues } from 'utils/api';
import { tollSchemeOptions } from 'utils/optionsHelper';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { IPreset } from 'types/apiTypes';
interface PresetStoreProps {
  presetsLoaded: boolean;
  actorValues: IPreset[];
  tollChargerValues: IPreset[];
  actionCodeValues: IPreset[];
  acknowledgmentValues: IPreset[];
  kapschEventTypes: IPreset[];
  paymentClaimTypeOfContentValues: IPreset[];
  tollSchemeValues: IPreset[];
  assetStatusValues: IPreset[];
  assetStatusTransitions: Record<string, string[]>;
  exceptionListTypeValues: IPreset[];
}

interface PresetStoreActions {
  setPresetValues: (
    newActors: IPreset[],
    newTollChargers: IPreset[],
    newActionCodes: IPreset[],
    newAcknowledgment: IPreset[],
    newKapschEventTypes: IPreset[],
    newTollSchemeValues: IPreset[],
    newPaymentClaimTypeOfContent: IPreset[],
    newAssetStatusValues: IPreset[],
    newAssetStatusTransitions: Record<string, string[]>,
    newExceptionListTypeValues: IPreset[]
  ) => void;
  fetchPresetValues: () => Promise<void>;
}

const usePresetStore = create(
  persist<PresetStoreProps & PresetStoreActions>(
    (set, get) => ({
      presetsLoaded: false,
      actorValues: [],
      tollChargerValues: [],
      actionCodeValues: [],
      acknowledgmentValues: [],
      kapschEventTypes: [],
      paymentClaimTypeOfContentValues: [],
      tollSchemeValues: [],
      assetStatusValues: [],
      assetStatusTransitions: {},
      exceptionListTypeValues: [],
      setPresetValues: (
        newActors,
        newTollChargers,
        newActionCodes,
        newAcknowledgment,
        newKapschEventTypes,
        newTollSchemeValues,
        newPaymentClaimTypeOfContent,
        newAssetStatusValues,
        newAssetStatusTransitions,
        newExceptionListTypeValues
      ) => {
        const prettyTollSchemeValues = newTollSchemeValues.map((tsv) => {
          return tollSchemeOptions.find((tso) => tso.value === tsv.value) ?? tsv;
        });

        set({
          actorValues: newActors,
          tollChargerValues: newTollChargers,
          actionCodeValues: newActionCodes,
          acknowledgmentValues: newAcknowledgment,
          kapschEventTypes: newKapschEventTypes,
          paymentClaimTypeOfContentValues: newPaymentClaimTypeOfContent,
          tollSchemeValues: prettyTollSchemeValues,
          assetStatusValues: newAssetStatusValues,
          assetStatusTransitions: newAssetStatusTransitions,
          exceptionListTypeValues: newExceptionListTypeValues,
          presetsLoaded: true,
        });
      },
      fetchPresetValues: async () => {
        const presetResult = await getPresetValues();
        const assetStatusTransitions: Record<string, string[]> = {};
        const assetStatusValues = (presetResult.assetStatuses ?? []).map((as) => {
          assetStatusTransitions[as.value] = as.allowedTransitions;
          return {
            label: as.label,
            value: as.value,
          } as IPreset;
        });

        get().setPresetValues(
          presetResult.actors ?? [],
          presetResult.tollChargers ?? [],
          presetResult.actionCodes ?? [],
          presetResult.ackTypes ?? [],
          presetResult.kapschEventTypes ?? [],
          presetResult.tollSchemes ?? [],
          presetResult.paymentClaimTypeOfContent ?? [],
          assetStatusValues,
          assetStatusTransitions ?? {},
          presetResult.exceptionListTypes ?? []
        );
      },
    }),
    {
      name: 'presetStorage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default usePresetStore;
